<h2 class="comp-title" style="margin-bottom: 25px;">Lead form</h2>
<div class="lead-form">
<h2>מעדיפים לדבר עם נציג?</h2>
<h3>השאירו פרטים ונחזור אליכם בהקדם</h3>
    <div class="form-wrapper dark-back">
        <!-- <app-form-field></app-form-field> -->
        <form class="example-form">
            <mat-form-field class="example-full-width">
                <mat-label>שם</mat-label>
                <input type="text" matInput [formControl]="textFormControl" placeholder="">

                <!-- <mat-error *ngIf="textFormControl.hasError('required')">
                  name is required
                </mat-error> -->
              </mat-form-field>
            <mat-form-field class="example-full-width">
                <mat-label>שם משפחה</mat-label>
                <input type="text" matInput [formControl]="textFormControl" placeholder="" value="">
              </mat-form-field>
              <mat-form-field class="example-full-width">
                <mat-label>תעודת זהות</mat-label>
                <input type="text" matInput [formControl]="textFormControl" placeholder="" value="">
              </mat-form-field>
              <mat-form-field class="example-full-width">
                <mat-label>טלפון</mat-label>
                <input type="text" matInput [formControl]="textFormControl" placeholder="" value="">
              </mat-form-field>


        </form>
        <div class="button-wrapper">
        <a href="#" class="brand-button white-button no-border" title=""><span>שלח</span></a>
        <a href="#" class="link arrow-link" title="">אפשר לדבר איתנו גם בוואטסאפ</a>
        </div>
    </div>
</div>